import styled from 'styled-components';

export const Container = styled.div`
  padding: ${({ theme }) => `0 ${theme.spacing(3)} 0 ${theme.spacing(5)}`};
`;
